// Stockpile Market minigame. The price is a mean-reverting random walk — in
// guest mode the client walks it locally; in cloud mode the server walks it on
// cron and the client just reads it. Either way the next move is unknown, so
// this is speculation, not arbitrage of a public curve. Kept in step with the
// SQL saf_market_tick / saf_market_buy / saf_market_sell.
export const MARKET_BASE = 1000;
export const MARKET_FEE = 0.03;
export const MARKET_POSITION_SECONDS = 600;

export function walkMarketPrice(price) {
  const reverted = price + (MARKET_BASE - price) * 0.04;
  const stepped = reverted * (1 + (Math.random() - 0.5) * 0.12);
  return Math.max(50, Math.round(stepped * 100) / 100);
}
